export default "__VITE_ASSET__0863a64a__"